import { useMemo } from 'react';

import { useSearchContext } from '@cast/shared-search-ui';

export const useSearchContextClusters = <T>() => {
  const searchContext = useSearchContext<T>();

  const allClusters = useMemo(
    () => searchContext?.data ?? [],
    [searchContext?.data]
  );

  const clusters = useMemo(
    () => searchContext?.filteredData ?? [],
    [searchContext?.filteredData]
  );

  const isLoading = searchContext?.isLoading ?? false;
  const error = searchContext?.error;
  const refetch = searchContext?.refetch;
  const noResultWithAppliedFilters =
    searchContext?.noResultWithAppliedFilters ?? false;
  const hasFilteredEmpty = allClusters.length > 0 && clusters.length === 0;

  return {
    allClusters,
    clusters,
    isLoading,
    error,
    refetch,
    noResultWithAppliedFilters,
    hasFilteredEmpty,
    searchContext,
  };
};
